<script>
	var form = {
		formState: 'input',
		mailErr: '',
		messageSent: false,
		isValid: false,
		bannedMails: ['@yopmail', '@lidte', '@vmani', '@seacob', '@firemailbox', '@tzymail', '@jourrapide', '@armyspy', '@cuvox', '@dayrep', '@einrot', '@fleckens', '@gustr', '@rhyta', '@superrito', '@teleworm'],
		inputs: {
			"firstname": {
				type: "text",
				required: true,
				valid: false,
				error: ""
			},
			"lastname": {
				type: "text",
				required: true,
				valid: false,
				error: ""
			},
			"company": {
				type: "alphanum",
				required: false,
				valid: false,
				error: ""
			},
			"email": {
				type: "email",
				required: true,
				valid: false,
				error: ""
			},
			"phone": {
				type: "number",
				required: true,
				valid: false,
				error: ""
			},
			"subject": {
				type: "alphanum",
				required: true,
				valid: false,
				error: ""
			},
			"message": {
				type: "alphanum",
				required: true,
				valid: false,
				error: ""
			},
		},
		verifyData: (id, isAddress) => {
			let data = document.querySelector('#'+id).value;
			let type = "text";
			let required = false;
			
			if(isAddress) {
				type = form.inputs.address[id].type;
				required = form.inputs.address[id].required;
			} else {
				type = form.inputs[id].type;
				required = form.inputs[id].required;
			}

			let valid = false;
			let error = "";

			if ((data == '' || data == null || data.trim() == '') && required) {
				error = "Champ vide";
			} else if((data == '' || data == null || data.trim() == '')) {
				if(isAddress) {
					form.inputs.address[id].valid = false;
					form.inputs.address[id].error = "";
					document.querySelector('#'+id).value = "";
				} else {
					form.inputs[id].valid = false;
					form.inputs[id].error = "";
					document.querySelector('#'+id).value = "";
				}
				return;
			} else {
				var r = null;
				var e = null;
				switch (type) {
					case "alphanum":
						r = /^[a-zA-Z\s\-àèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ€'.,;:!?()0-9]+$/gm;
						e = /[^a-zA-Z\s\-àèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ€'.,;:!?()0-9]+/igm;
						break;
					case "text":
						r = /^[a-zA-Z\s\-àèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ€'.,;:!?()]+$/gm;
						e = /[^a-zA-Z\s\-àèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ€'.,;:!?()]+/igm;
						break;
					case "number":
						r = /^[\d+ ]+$/gm;
						e = /[^\d+ ]+/gm;
						break;
					case "email":
						r = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/gm;
						break;
				}
				var test = r.test(data);

				if (test == true) {
					if (type == "email") {
						let isBanned = false;
						form.bannedMails.forEach(b => {
							if (data.includes(b)) isBanned = true;
						});
						if (isBanned == false) {
							valid = true;
						} else {
							error = "Adresse mail invalide";
						}
					} else {
						valid = true;
					}
				} else if (test == false) {
					if (type == "email") {
						error = "Adresse mail invalide";
					} else {
						if (data.match(e) != null) {
							if(isAddress) {
								error = data.match(e);
							} else {
								error = 'Caractères invalides: ' + data.match(e);
							}
						}
					}
				}
			}

			if(isAddress) {
				form.inputs.address[id].valid = valid;
				form.inputs.address[id].error = error;
				form.verifyAddress();
			} else {
				form.inputs[id].valid = valid;
				form.inputs[id].error = error;
			}

			form.verifyForm();
		},
		verifyForm: () => {
			let isValid = true;
			for (var input in form.inputs) {
				if (form.inputs.hasOwnProperty(input)) {
					if(form.inputs[input].required) {
						if(form.inputs[input].error != "" || document.getElementById(input).value == "" || document.getElementById(input).value == null) {
							isValid = false;
						}
					}
					if(!form.inputs[input].required && form.inputs[input].error != "") {
						isValid = false;
					}
				}
			}
			form.isValid = isValid;
		},
		resetForm: () => {
			document.querySelector('#resetBtn').click();
			for (var input in form.inputs) {
				if (form.inputs.hasOwnProperty(input)) {
					form.inputs[input].valid = false;
					form.inputs[input].error = "";
				}
			}
		},
		sendForm: async () => {
			form.formState = 'input';
			form.messageSent = false;

			var data = new FormData(document.getElementById('contact-form'));
			form.formState = 'sending';

			var res = await fetch("mailer.php", {
				method: "POST",
				body: data
			});

			var resData = await res.json();

			if(resData.status == "ok") {
				form.messageSent = true;
			} else {
				form.mailErr = resData.error;
			}

			form.formState = 'input';
			form.resetForm();

			return false;
		}
	};	
</script>

{#if form.messageSent == true}
	<div class="form-success">
		<div class="alert alert-success alert-dismissible">
			<button type="button" class="btn-close" data-bs-dismiss="alert" on:click={() => {form.messageSent = false}}></button>
			Votre message a bien été envoyé !
		</div>
	</div>
{/if}
{#if form.mailErr != ''}
	<div class="form-success">
		<div class="alert alert-danger alert-dismissible">
			<button type="button" class="btn-close" data-bs-dismiss="alert" on:click={() => {form.mailErr = ''}}></button>
			Erreur: {form.mailErr}
		</div>
	</div>
{/if}
{#if form.formState == 'sending'}
	<div class="spinner-container">
		<div class="spinner-border"></div>
		<span class="spinner-text">Envoi de votre message</span>
	</div>
{/if}

<form action="" class:sending={form.formState == "sending"} id="contact-form" method="POST">
	<button type="reset" id="resetBtn" style="display:none">r</button>
	<input type="hidden" name="65ze4f6ze4" id="65ze4f6ze4" style="display:none">
	<div class="row">
		<div class="col-sm-5">
			<div class="form-input-container">
				<label for="firstname" class="form-label">
					<span>Prénom</span>
					<span class="input-status" class:required={form.inputs['firstname'].error == "" && form.inputs['firstname'].required && !form.inputs['firstname'].valid} class:valid={form.inputs['firstname'].error == "" && form.inputs['firstname'].valid} class:error={form.inputs['firstname'].error != "" && !form.inputs['firstname'].valid}>
						{#if form.inputs['firstname'].error == "" && form.inputs['firstname'].required && !form.inputs['firstname'].valid}
							*
						{:else if form.inputs['firstname'].error == "" && form.inputs['firstname'].valid}
							<i class="fas fa-check"></i>
						{:else if form.inputs['firstname'].error != "" && !form.inputs['firstname'].valid}
							<i class="fas fa-times"></i> {form.inputs['firstname'].error}
						{/if}
					</span>
				</label>
				<input type="text" class="form-control" id="firstname" name="firstname" required on:change={() => {form.verifyData('firstname', false)}} class:valid={form.inputs['firstname'].valid} class:error={form.inputs['firstname'].error != "" && !form.inputs['firstname'].valid}>
			</div>
		</div>
		<div class="col-sm-7">
			<div class="form-input-container">
				<label for="lastname" class="form-label">
					<span>Nom</span>
					<span class="input-status" class:required={form.inputs['lastname'].error == "" && form.inputs['lastname'].required && !form.inputs['lastname'].valid} class:valid={form.inputs['lastname'].error == "" && form.inputs['lastname'].valid} class:error={form.inputs['lastname'].error != "" && !form.inputs['lastname'].valid}>
						{#if form.inputs['lastname'].error == "" && form.inputs['lastname'].required && !form.inputs['lastname'].valid}
							*
						{:else if form.inputs['lastname'].error == "" && form.inputs['lastname'].valid}
							<i class="fas fa-check"></i>
						{:else if form.inputs['lastname'].error != "" && !form.inputs['lastname'].valid}
							<i class="fas fa-times"></i> {form.inputs['lastname'].error}
						{/if}
					</span>
				</label>
				<input type="text" class="form-control" id="lastname" name="lastname" required on:change={() => {form.verifyData('lastname', false)}} class:valid={form.inputs['lastname'].valid} class:error={form.inputs['lastname'].error != "" && !form.inputs['lastname'].valid}>
			</div>
		</div>
	</div>
	<div class="row">
		<div class="col-sm-7">
			<div class="form-input-container">
				<label for="email" class="form-label">
					<span>Adresse e-mail</span>
					<span class="input-status" class:required={form.inputs['email'].error == "" && form.inputs['email'].required && !form.inputs['email'].valid} class:valid={form.inputs['email'].error == "" && form.inputs['email'].valid} class:error={form.inputs['email'].error != "" && !form.inputs['email'].valid}>
						{#if form.inputs['email'].error == "" && form.inputs['email'].required && !form.inputs['email'].valid}
							*
						{:else if form.inputs['email'].error == "" && form.inputs['email'].valid}
							<i class="fas fa-check"></i>
						{:else if form.inputs['email'].error != "" && !form.inputs['email'].valid}
							<i class="fas fa-times"></i> {form.inputs['email'].error}
						{/if}
					</span>
				</label>
				<input type="email" class="form-control" name="email" id="email" required on:change={() => {form.verifyData('email', false)}} class:valid={form.inputs['email'].valid} class:error={form.inputs['email'].error != "" && !form.inputs['email'].valid}>
			</div>
		</div>
		<div class="col-sm-5">
			<div class="form-input-container">
				<label for="phone" class="form-label">
					<span>Téléphone</span>
					<span class="input-status" class:required={form.inputs['phone'].error == "" && form.inputs['phone'].required && !form.inputs['phone'].valid} class:valid={form.inputs['phone'].error == "" && form.inputs['phone'].valid} class:error={form.inputs['phone'].error != "" && !form.inputs['phone'].valid}>
						{#if form.inputs['phone'].error == "" && form.inputs['phone'].required && !form.inputs['phone'].valid}
							*
						{:else if form.inputs['phone'].error == "" && form.inputs['phone'].valid}
							<i class="fas fa-check"></i>
						{:else if form.inputs['phone'].error != "" && !form.inputs['phone'].valid}
							<i class="fas fa-times"></i> {form.inputs['phone'].error}
						{/if}
					</span>
				</label>
				<input type="phone" class="form-control" name="phone" id="phone" required on:change={() => {form.verifyData('phone', false)}} class:valid={form.inputs['phone'].valid} class:error={form.inputs['phone'].error != "" && !form.inputs['phone'].valid}>
			</div>
		</div>
	</div>
	<div class="row">
		<div class="col-sm-5">
			<div class="form-input-container">
				<label for="company" class="form-label">
					<span>Entreprise</span>
					<span class="input-status" class:valid={form.inputs['company'].error == "" && form.inputs['company'].valid} class:error={form.inputs['company'].error != "" && !form.inputs['company'].valid}>
						{#if form.inputs['company'].error == "" && form.inputs['company'].valid}
							<i class="fas fa-check"></i>
						{:else if form.inputs['company'].error != "" && !form.inputs['company'].valid}
							<i class="fas fa-times"></i> {form.inputs['company'].error}
						{/if}
					</span>
				</label>
				<input type="text" class="form-control" name="company" id="company" on:change={() => {form.verifyData('company', false)}} class:valid={form.inputs['company'].valid} class:error={form.inputs['company'].error != "" && !form.inputs['company'].valid}>
			</div>
		</div>
		<div class="col-sm-7">
			<div class="form-input-container">
				<label for="subject" class="form-label">
					<span>Sujet</span>
					<span class="input-status" class:required={form.inputs['subject'].error == "" && form.inputs['subject'].required && !form.inputs['subject'].valid} class:valid={form.inputs['subject'].error == "" && form.inputs['subject'].valid} class:error={form.inputs['subject'].error != "" && !form.inputs['subject'].valid}>
						{#if form.inputs['subject'].error == "" && form.inputs['subject'].required && !form.inputs['subject'].valid}
							*
						{:else if form.inputs['subject'].error == "" && form.inputs['subject'].valid}
							<i class="fas fa-check"></i>
						{:else if form.inputs['subject'].error != "" && !form.inputs['subject'].valid}
							<i class="fas fa-times"></i> {form.inputs['subject'].error}
						{/if}
					</span>
				</label>
				<select name="subject" id="subject" class="form-select" required on:change={() => {form.verifyData('subject', false)}} class:valid={form.inputs['subject'].valid} class:error={form.inputs['subject'].error != "" && !form.inputs['subject'].valid}>
					<option value=""></option>
					<option value="infFormation">Information au sujet d'une formation</option>
					<option value="inscFormation">Inscription à une formation</option>
					<option value="infGenerale">Information générale</option>
				</select>
			</div>
		</div>
	</div>
	<div class="row">
		<div class="col-sm-12">
			<div class="form-input-container">
				<label for="message" class="form-label">
					<span>Message</span>
					<span class="input-status" class:required={form.inputs['message'].error == "" && form.inputs['message'].required && !form.inputs['message'].valid} class:valid={form.inputs['message'].error == "" && form.inputs['message'].valid} class:error={form.inputs['message'].error != "" && !form.inputs['message'].valid}>
						{#if form.inputs['message'].error == "" && form.inputs['message'].required && !form.inputs['message'].valid}
							*
						{:else if form.inputs['message'].error == "" && form.inputs['message'].valid}
							<i class="fas fa-check"></i>
						{:else if form.inputs['message'].error != "" && !form.inputs['message'].valid}
							<i class="fas fa-times"></i> {form.inputs['message'].error}
						{/if}
					</span>
				</label>
				<textarea class="form-control" name="message" id="message" cols="30" rows="10" on:change={() => {form.verifyData('message', false)}} class:valid={form.inputs['message'].valid} class:error={form.inputs['message'].error != "" && !form.inputs['message'].valid}></textarea>
			</div>
		</div>
	</div>
	<div class="row">
		<div class="col-sm-12">
			<button type='button' on:click={form.sendForm()} class="btn btn-success float-end" class:disabled={!form.isValid}><i class="fa-solid fa-paper-plane"></i> Envoyer</button>
		</div>
	</div>
</form>